module.exports = __webpack_public_path__ + "img/doc-trash.19731244.svg";